import React from 'react';
import { PRODUCT_TYPES } from './Product'

export const LOCATION_SEARCH = {
  type: "locations",
  term: {
    label: "Search",
    field: "name"
  }
}

export const LOCATION_ITEM_SEARCH = {
  type: "location-items",
  links: ["item","image"],
  limit: 50,
  term: {
    label: "Products",
    placeholder: "Search",
    fields: ["item.name","item.sku"],
    keymap: {
      id: "id",
      item: "item.id",
      sku: "item.sku",
      name: "item.name",
      location: {field:"location.name", op:"contains"},
      product: {field:"item.name", op:"contains"}
    }
  },
  filters: [
    {
      label: "Type",
      type: "check",
      field: "item.type",
      options: PRODUCT_TYPES
    }
  ],
  sort: [
    { field: "createdAt",        name: "Created (Asc)",   direction:"asc"},
    { field: "createdAt",        name: "Created (Desc)",  direction:"desc"},
    { field: "item.name",        name: "Name (A-Z)",      direction:"asc", selected: true},
    { field: "item.name",        name: "Name (Z-A)",      direction:"desc"},
    { field: "item.sku",         name: "SKU (A-Z)",       direction:"asc"},
    { field: "item.sku",         name: "SKU (Z-A)",       direction:"desc"},
    { field: "item.type",        name: "Type (A-Z)",      direction:"asc"},
    { field: "item.type",        name: "Type (Z-A)",      direction:"desc"}
  ]
}
